export const ServiceType = {
    AUTH_CHECK: "authcheck",
    DRAFT_PREVIEW: "preview"
}

export const ResourceType = {
    TEXT: "Text",
    VIDEO: "Video",
    POWERPOINT: "Powerpoint"
}